import React, { FC } from "react";
import { Box, Typography } from "@mui/material";

interface Props {
  value: string | number;
  unit: string;
  icon: string;
  heading: string;
}

export const SingleSummaryBox: FC<Props> = ({ heading, icon, value, unit }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      border: "1px solid var(--border)",
      padding: "16px",
      borderRadius: "10px",
      gap: "30px",
    }}
  >
    <Box width="25px" flexShrink="0">
      <img className="rounded" src={icon} alt={`icon-${icon}`} />
    </Box>
    <Box color="text.secondary" gap="5px" display="flex" flexDirection="column" fontFamily="CircularStd">
      {heading}
      <Box
        display="flex"
        gap="5px"
        alignItems="flex-end"
        justifyContent="flex-start"
      >
        <Typography
          variant="body1"
          fontSize="34px"
          lineHeight="40px"
          fontFamily="CircularStdBlack"
          fontWeight={900}
          color="text.primary"
        >
          {value}
        </Typography>
        <Typography
          variant="body2"
          fontSize="14px"
          lineHeight="22px"
          fontFamily="CircularStdBlack"
        >
          {unit}
        </Typography>
      </Box>
    </Box>
  </Box>
);
